import React from 'react';

import { IWidgetCardProps } from '@entities/widget-card/model/types';
import { WidgetCardStatus } from '@entities/widget-card/ui/card/WidgetCardStatus';
import { sliceLastFromString } from '@shared/helpers';
import { UiText } from '@shared/ui';

import cls from './WidgetCard.module.css';

const formatPaymentDetailsText = (text: string) =>
    text
        .split(/<\/?br\s*\/?>/gi)
        .flatMap((part, index, arr) =>
            index < arr.length - 1 ? [part, <br key={`payment-break-${index}`} />] : [part]
        );

export const WidgetCard = ({
    title,
    shortDescription,
    paymentDetailsText,
    status,
    logoUrl,
    gradient,
    actionBtnGroupSlot,
    onCardClick,
}: IWidgetCardProps) => (
    <li
        style={{
            background: sliceLastFromString({ str: gradient, symbolToSlice: ';' }),
        }}
        className={cls.WidgetCardContainer}
        onClick={onCardClick}
    >
        <header className={cls.WidgetCardHeader}>
            <UiText tag="h4" className={cls.WidgetCardTitle} variant="boldPlain" weight="medium">
                {title}
            </UiText>
            <WidgetCardStatus status={status} />
        </header>
        <main className={cls.WidgetCardMain}>
            {status != 'enabled' && shortDescription && (
                <UiText className={cls.WidgetCardSubtitle} variant="boldPlain">
                    {shortDescription}
                </UiText>
            )}
            <UiText tag="span" className={cls.WidgetCardPaymentDetails} variant="boldPlain">
                {formatPaymentDetailsText(paymentDetailsText)}
            </UiText>
        </main>
        <footer className={cls.WidgetCardFooter}>
            {actionBtnGroupSlot}
            {logoUrl != null && (
                <span className={cls.WidgetCardLogo}>
                    <img src={logoUrl} alt="widget logo" />
                </span>
            )}
        </footer>
    </li>
);
